import { createContext, useContext } from 'react';
import type { useGameState } from './useGameState';

export type GameStateApi = ReturnType<typeof useGameState>;

// One useGameState instance lives in App and is shared through this context. Calling the hook
// again in a child component would start a second polling loop against the server.
const GameStateContext = createContext<GameStateApi | null>(null);

export const GameStateProvider = GameStateContext.Provider;

export function useGameStateContext(): GameStateApi {
  const api = useContext(GameStateContext);
  if (!api) {
    throw new Error('useGameStateContext must be used inside GameStateProvider');
  }
  return api;
}
